var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesCampain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.51 11.14-5-3A1 1 0 0 0 9 9v6a1 1 0 0 0 .51.87A1 1 0 0 0 10 16a1 1 0 0 0 .51-.14l5-3a1 1 0 0 0 0-1.72ZM11 13.23v-2.46L13.06 12Z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 16V8a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4v3a1 1 0 0 0 .62.92A.84.84 0 0 0 7 24a1 1 0 0 0 .71-.29l3.7-3.71H18a4 4 0 0 0 4-4Zm-11 2a1 1 0 0 0-.71.29L8 20.59V19a1 1 0 0 0-1-1H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 8h-1a1 1 0 0 0 0 2h1a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-1a1 1 0 0 0-1 1v1.59l-2.29-2.3A1 1 0 0 0 21 22h-7a1.93 1.93 0 0 1-1-.29 1 1 0 1 0-1.06 1.7A3.93 3.93 0 0 0 14 24h6.59l3.7 3.71A1 1 0 0 0 25 28a.84.84 0 0 0 .38-.08A1 1 0 0 0 26 27v-3a4 4 0 0 0 4-4v-8a4 4 0 0 0-4-4Z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesCampain);
export default __webpack_public_path__ + "static/media/sales-campain.4f4e30365b6e7b20e2c70766637d79b6.svg";
export { ForwardRef as ReactComponent };